import { cn } from "@/lib/cn";

export type ModoDaGrade = "categorias" | "lista";

/** Cartões fechados (abre um por vez, logo abaixo da linha dele) ou a lista com tudo aberto. */
export function SeletorDeModo({ modo, onChange, rotuloDasCategorias }: { modo: ModoDaGrade; onChange: (m: ModoDaGrade) => void; rotuloDasCategorias: string }) {
  return (
    <div role="tablist" className="inline-flex h-9 shrink-0 items-center rounded-md border border-zinc-200 bg-white p-0.5 dark:border-border dark:bg-card">
      {(
        [
          ["categorias", rotuloDasCategorias],
          ["lista", "Lista"],
        ] as const
      ).map(([chave, rotulo]) => (
        <button
          key={chave}
          type="button"
          role="tab"
          aria-selected={modo === chave}
          onClick={() => onChange(chave)}
          className={cn(
            "inline-flex h-8 items-center rounded px-3 text-sm font-medium transition-colors",
            modo === chave ? "bg-brand-600 font-semibold text-white" : "text-zinc-600 hover:text-zinc-900 dark:text-muted-foreground",
          )}
        >
          {rotulo}
        </button>
      ))}
    </div>
  );
}
